import templateUrl from './errorBanner.html';

export default {
  templateUrl,
  controllerAs: 'ctrl',
  bindings: {
    messages: '=',
  },
};
